// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './components/NavGroup/NavGroup';
import menuItem from 'components/menu-items';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = ({ isMinimized, isMobile = false }) => {
  const navItems = menuItem.items.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} isMinimized={isMinimized} isMobile={isMobile}/>;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return < >{navItems}</>;
};

export default MenuList;
